import { DocumentUploadStore } from '@modules/documents/children/upload/types/store';

export const initialState: DocumentUploadStore = {
  isFetching: false
};
